module.exports = __webpack_public_path__ + "img/fi-rr-refresh.6e34a5f4.svg";